import { Companion_getInstance1bxbth0yni76u as Companion_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/uuid/Uuid.mjs';
import {
  toNotBlankString1ovj48s0kinvm as toNotBlankString,
  NotBlankString__toString_impl_5tex9r2ig2s5isyc5ve as NotBlankString__toString_impl_5tex9r,
  NotBlankString__hashCode_impl_fxqzj41ooh7w2aare6h as NotBlankString__hashCode_impl_fxqzj4,
} from '../../../../../types-types/kotools/types/text/NotBlankString.mjs';
import {
  throwOnFailure24snjmtlqgzo8 as throwOnFailure,
  _Result___get_value__impl__bjfvqg316j9v81zgqwq as _Result___get_value__impl__bjfvqg,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      p2a() {
        // Inline function 'kotlin.getOrThrow' call
        var this_0 = toNotBlankString(Companion_getInstance().vt().toString());
        throwOnFailure(this_0);
        var tmp$ret$0 = _Result___get_value__impl__bjfvqg(this_0).o29_1;
        return new (ContributionId())(tmp$ret$0);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  return Companion_instance;
}
var ContributionIdClass;
function ContributionId() {
  if (ContributionIdClass === VOID) {
    class $ {
      constructor(value) {
        this.q2a_1 = value;
      }
      toString() {
        return 'ContributionId(value=' + NotBlankString__toString_impl_5tex9r(this.q2a_1) + ')';
      }
      hashCode() {
        return NotBlankString__hashCode_impl_fxqzj4(this.q2a_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ContributionId()))
          return false;
        if (!(this.q2a_1 === other.q2a_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ContributionId');
    ContributionIdClass = $;
  }
  return ContributionIdClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  ContributionId as ContributionId1kgq0od2ulxrt,
  Companion_instance as Companion_instance8hlg2a25e23m,
};
//endregion

//# sourceMappingURL=ContributionId.mjs.map
